// extracted by mini-css-extract-plugin
var _1 = "_earmarkApprovalTable-module__action-button";
var _2 = "_earmarkApprovalTable-module__action-button-container";
var _3 = "_earmarkApprovalTable-module__approve";
var _4 = "_earmarkApprovalTable-module__button-container";
var _5 = "_earmarkApprovalTable-module__danger";
var _6 = "_earmarkApprovalTable-module__discount-type-date";
var _7 = "_earmarkApprovalTable-module__discount-type-text";
var _8 = "_earmarkApprovalTable-module__gold-row";
var _9 = "_earmarkApprovalTable-module__reject";
var _a = "_earmarkApprovalTable-module__title";
export { _1 as "action-button", _2 as "action-button-container", _3 as "approve", _4 as "button-container", _5 as "danger", _6 as "discount-type-date", _7 as "discount-type-text", _8 as "gold-row", _9 as "reject", _a as "title" }
